<!--物料号采购降成本-->
<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="物料编码/名称" prop="materialCode">
              <el-input v-model="formInline.materialCode" placeholder="请输入"
                        style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="供应商编码/名称" prop="billNo">
                <el-input v-model="formInline.supplierCode" placeholder="请输入"
                          style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="产品大类" prop="materialCategoryCode">
              <brselectlazy style="width: 100%;" category="product_level" :v="formInline.materialCategoryCode" v-model="formInline.materialCategoryCode" :clearable="true"/>
            </el-form-item>
            <el-form-item label="年份" prop="year">
              <el-date-picker
                  v-model="formInline.year"
                  type="year"
                  value-format="yyyy"
                  placeholder="选择年">
              </el-date-picker>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="产品型号" prop="materialModel">
                  <el-input v-model="formInline.materialModel" placeholder="请输入"
                            style="width: 100%"></el-input>
                </el-form-item>
              </div>
            </div>
          </el-collapse-transition>
        </el-form>
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
          </div>
        </div>
      </div>
      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table
            :data="tableData"
            ref="multipleTable"
            :border="true"
            style="width: 100%"
            max-height="450"
        >
          <el-table-column
              label="物料编码"
              prop="materialCode"
              width="110"
              fixed
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="物料名称"
              prop="materialName"
              width="170"
              fixed
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="供应商编码"
              prop="supplierCode"
              width="100"
              fixed
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="供应商描述"
              prop="supplierName"
              width="200"
              fixed
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="产品大类"
              prop="materialCategory"
              width="90"
              fixed
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="二级分类"
              prop="materialSecondaryCategory"
              width="90"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="产品型号"
              prop="materialModel"
              width="170"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="年份"
              prop="statYear"
              width="90"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="入库数量"
              prop="annualReceiptQty"
              width="90"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="采购额"
              prop="annualActualAmount"
              width="100"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="降价总额"
              prop="annualReductionTotal"
              width="100"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="采购降价额"
              prop="annualPurchaseReductionTotal"
              width="110"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="链群降价额"
              prop="annualChainReductionTotal"
              width="110"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="降幅"
              prop="annualReductionRate"
              width="100"
              show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatReductionRate(scope.row.annualReductionRate) }}
            </template>
          </el-table-column>
          <el-table-column label="1月">
            <el-table-column
                label="入库数量"
                prop="receiptQty01"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount01"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal01"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate01"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate01) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="2月">
            <el-table-column
                label="入库数量"
                prop="receiptQty02"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount02"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal02"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate02"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate02) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="3月">
            <el-table-column
                label="入库数量"
                prop="receiptQty03"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额)"
                prop="actualAmount03"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal03"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate03"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate03) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="4月">
            <el-table-column
                label="入库数量"
                prop="receiptQty04"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount04"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal04"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate04"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate04) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="5月">
            <el-table-column
                label="入库数量"
                prop="receiptQty05"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount05"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal05"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate05"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate05) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="6月">
            <el-table-column
                label="入库数量"
                prop="receiptQty06"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount06"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal06"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate06"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate06) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="7月">
            <el-table-column
                label="入库数量"
                prop="receiptQty07"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount07"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal07"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate07"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate07) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="8月">
            <el-table-column
                label="入库数量"
                prop="receiptQty08"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount08"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal08"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate08"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate08) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="9月">
            <el-table-column
                label="入库数量"
                prop="receiptQty09"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount09"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal09"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate09"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate09) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="10月">
            <el-table-column
                label="入库数量"
                prop="receiptQty10"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount10"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal10"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate10"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate10) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="11月">
            <el-table-column
                label="入库数量"
                prop="receiptQty11"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount11"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal11"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate11"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate11) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="12月">
            <el-table-column
                label="入库数量"
                prop="receiptQty12"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="采购额"
                prop="actualAmount12"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降价总额"
                prop="reductionTotal12"
                width="100"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="降幅"
                prop="reductionRate12"
                width="100"
                show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatReductionRate(scope.row.reductionRate12) }}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <div class="h-tableBL">
              <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcelAll">批量导出
              </el-button>
            </div>
          </div>
          <div class="h-pagination2">
            <pagination :page="formInline" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reduceCost from "@/api/invoice/reduceCost";
import uploaddownexcel from "@/components/uploaddown/uploaddownexceltarget.vue";
import updownfile from '../../utils/updownfile'
export default {
  components: {uploaddownexcel},
  data() {
    return {
      formInline:{
        materialCode: '',
        materialCategoryCode: '',
        materialModel: '',
        year: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
    }
  },
  methods:{
    collapseChange() { this.isScreen = !this.isScreen; },
    formatReductionRate(rate) {
      // 1. 乘以100并保留2位小数（处理精度问题）
      const multiplied = (rate * 100).toFixed(2);
      // 2. 格式化显示：
      // - .00 → 去除小数部分（如12.00→12）
      // - .x0 → 保留一位小数（如12.50→12.5）
      // - 其他 → 保留两位小数（如11.36→11.36）
      const formatted = multiplied
          .replace(/\.00$/, '')       // 处理整数情况
          .replace(/(\.\d)0$/, '$1'); // 处理.x0情况

      return `${formatted}%`;
    },
    handleFilter(){
      this.formInline.pageNo = 1
      this.query()
    },
    resetData(){
      this.formInline = {
        materialCode: '',
        materialCategory: '',
        materialModel: '',
        year: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
      this.query()
    },
    //导出
    exportExcelAll() {
      // updownfile.down("/api/swyl/v1/dscCostReduction/downloadMaterialExcel", this.formInline, "post", 'data');
      updownfile.down("/api/swyl/v1/dscCostReduction/downloadMaterialNewExcel", this.formInline, "post", 'data');
    },
    query(){
      // reduceCost.getMaterialCostReduction(this.formInline).then(res=>{
      reduceCost.getMaterialCostReductionNew(this.formInline).then(res=>{
        this.tableData = res.records;
        this.formInline.total = res.total;
      })
    },
  },
  created() {
    this.query();
  },
  activated() {
    this.query()
  }
}
</script>
<style>

</style>